module.exports = __webpack_public_path__ + "img/Bentley-LocalCSystem.bed2f2f5.png";